import { AccordionItem, AccordionPanel } from '@chakra-ui/react';
import RingGroupExtendedAttributes from './RingGroupExtendedAttributes';
import RingGroupAccordionSectionButton from './RingGroupAccordionSectionButton';

export default function RingGroupExtendedAttributesSection({
    attributes,
    darkMode,
    panelBg,
    accordionBorderColor,
}) {
    return (
        <AccordionItem
            borderColor={accordionBorderColor}
            mb={2}
            borderWidth="1px"
            borderRadius="md"
            overflow="hidden">
            <RingGroupAccordionSectionButton darkMode={darkMode}>
                Extended Attributes
            </RingGroupAccordionSectionButton>
            <AccordionPanel px={4} py={4} bg={panelBg}>
                <RingGroupExtendedAttributes
                    attributes={attributes}
                    darkMode={darkMode}
                />
            </AccordionPanel>
        </AccordionItem>
    );
}
